import { atom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { FOOTBALL_IDENTIFIER } from '../components/Sport/Sport';

export const DEFAULT_PERIOD = '1';
export const DEFAULT_TRACK = '1';
export const DEFAULT_VERSION = '1';
export const DEFAULT_METADATA_SELECTION = {
  matchId: '',
  period: DEFAULT_PERIOD,
  sport: FOOTBALL_IDENTIFIER,
  track: DEFAULT_TRACK,
  version: DEFAULT_VERSION,
};
export const selectedMetadataAtom = atom(DEFAULT_METADATA_SELECTION);
selectedMetadataAtom.debugLabel = 'selectedMetadataAtom';

export const selectedSportAtom = focusAtom(selectedMetadataAtom, (optic) =>
  optic.prop('sport'),
);
selectedSportAtom.debugLabel = 'selectedSport';

export const selectedMatchIdAtom = focusAtom(selectedMetadataAtom, (optic) =>
  optic.prop('matchId'),
);
selectedMatchIdAtom.debugLabel = 'selectedMatchId';
